import { $ } from 'utils'
import styled from 'glamorous'
import { css } from 'glamor'
import { map } from 'lodash'
import Link from 'react-router-dom/Link'
import { withRouter } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import ListItem from './ListItem'

const Container = styled.div({
  width: '100%',
  height: '100%',
})

const Header = styled.div({
  display: 'flex',
  height: 60,
  width: '100%',
  backgroundColor: 'white',
  borderBottom: '1px solid var(--borderColor)',
})

const TabContainer = styled.div({
  width: 150,
  height: '100%',
  boxSizing: 'border-box',
}, ({ selected }) => selected && ({
  borderBottom: '3px solid var(--violet)',
  fontWeight: 'bold'
}))

const SimpleLink = styled(Link)({
  textDecoration: 'none',
  color: 'var(--black)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
})

const PageContent = styled(PerfectScrollbar)({
  width: '100%',
  height: 'calc(100% - 60px)',
  overflow: 'auto'
}, 'lists-scrollable')
// not touch this className 'lists-scrollable' - it need for hide scroll
css.global('.lists-scrollable .ps__rail-y', {
  opacity: '0 !important'
})
// it fix micro-scroll bug on Windows.
css.global('.lists-scrollable', {
  position: 'static'
})

const personTab = '/list/persons'
const faceTab = '/list/faces'

export const ListPages = ({ selectedTab, lists }) =>
  $(Container,
    $(Header,
      $(TabContainer, { selected: selectedTab === 'persons' },
        $(SimpleLink, { to: personTab }, 'Persons lists'),
      ),
      $(TabContainer, { selected: selectedTab === 'faces' },
        $(SimpleLink, { to: faceTab }, 'Faces lists'),
      ),
    ),
    $(PageContent, map(lists, (list) =>
      $(ListItem, { key: list.uuid, list, tab: selectedTab }))
    )
  )

export default withRouter(ListPages)



// WEBPACK FOOTER //
// ./src/pages/Lists/ListPages.js